import { Input } from 'antd';
import React from 'react'
import { ColDef } from 'ag-grid-community';
import { IListHistoryLog } from '../../../../api/Customer_V2/customerApi_V2';
import { NodataTable } from '../../../../components/NoDataTable';
import { AgGridReact } from 'ag-grid-react';


const { Search } = Input;

interface Props {

    title?: string
    data: IListHistoryLog[]
    onSearch: (value: string) => void
    columns: ColDef<IListHistoryLog, any>[]
}

const HistoryCard: React.FC<Props> = ({
    title, data, columns, onSearch
}) => {

    return (
        <div className='custom-page-css w-full flex flex-col gap-2'>
            <div className="title-fz16-medium text-344054">{title || 'Quyền lợi hạng thẻ khách hàng'}</div>
            <Search placeholder="Tìm tên hoạt động" onSearch={onSearch} className='custom-input-css custom-page-css' />
            <div className="t-table-block t-table-add-rank">
                <div className="ag-theme-alpine custom-table-ag custom-page-css" style={{ width: '100%' }}>
                    <AgGridReact
                        className="my-auto-height-grid"
                        domLayout="autoHeight"
                        getRowStyle={(params: any) => ({
                            backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                        })}
                        rowData={data}
                        rowHeight={55}
                        columnDefs={columns}
                        overlayNoRowsTemplate={NodataTable}
                        suppressDragLeaveHidesColumns={true}
                    />
                </div>
            </div>
        </div>


    )
}

export default HistoryCard